import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const receivedPdfFile = createAsyncThunk(
  "receivedpdf/fetch",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${base_url}/digilocker/GetDocumentPathReceived/${uuid}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ReceivedPDFSlice = createSlice({
  name: "receivedPDF",
  initialState: {
    ReceivedPdfDta: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(receivedPdfFile.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(receivedPdfFile.fulfilled, (state, action) => {
        state.ReceivedPdfDta = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(receivedPdfFile.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default ReceivedPDFSlice.reducer;
